<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 20px;">
        <div class="col-md-12">
            <label class="header_text mb-1">
                {{$t('shared.updateDataRequests')}} - {{ details.displayId }}
            </label>
        </div>
    </div>

    <div v-if="showPendingAdminView">
        <div class="row">
            <div class="col-md-12">
                <div class="card card_layout">
                    <div class="card-body ur-card-body">
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label class="user_info_header mb-0">{{$t('updateDataRequestsPage.senderName')}}</label>
                                <h4 class="user_info_txt">{{ details.senderName || '-' }}</h4>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="user_info_header mb-0">{{$t('updateDataRequestsPage.clientName')}}</label>
                                <h4 class="user_info_txt">{{ details.clientName || '-' }}</h4>
                            </div>
                            <div class="col-md-4 mb-3" v-if="showReferenceNumber">
                                <label class="user_info_header mb-0">{{ referenceLabel }}</label>
                                <h4 class="user_info_txt">{{ details.crNumber || '-' }}</h4>
                            </div>
                            <div class="col-md-4 mb-3" v-if="showEnterpriseUnifiedNumber">
                                <label class="user_info_header mb-0">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                <h4 class="user_info_txt">{{ details.enterpriseUnifiedNumber || '-' }}</h4>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="user_info_header mb-0">{{$t('shared.senderType')}}</label>
                                <h4 class="user_info_txt">{{ getSenderTypeText(details.senderType) }}</h4>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="user_info_header mb-0">{{$t('shared.senderExpiryDate')}}</label>
                                <h4 class="user_info_txt">{{ details.senderExpiryDate || '-' }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" style="margin-top: 24px;">
            <div class="col-md-12">
                <div class="card card_layout">
                    <div class="card-body ur-card-body">
                        <div class="table-responsive">
                            <table class="table mb-0 ur-comparison-table ur-comparison-table-bordered">
                                <thead>
                                    <tr>
                                        <th>{{$t('updateDataRequestsPage.fieldName')}}</th>
                                        <th>{{$t('updateDataRequestsPage.currentInformation')}}</th>
                                        <th class="ur-arrow-col"></th>
                                        <th>{{$t('updateDataRequestsPage.requestedInformation')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(field, idx) in comparisonFields" :key="'cmp-' + idx">
                                        <td>{{ field.fieldName }}</td>
                                        <td>
                                            <div v-if="field.isAttachment && field.currentAttachmentId"
                                                 class="ur-attachment-chip ur-field-sized">
                                                <i class="fas fa-file-pdf ur-chip-icon"></i>
                                                <span class="ur-chip-name">
                                                    {{ field.currentValue || $t('shared.delegationLetter') }}
                                                </span>
                                                <i class="fas fa-download ur-chip-download"
                                                   @click="downloadSenderRequestAttachment(field.currentAttachmentId, field.currentValue)"></i>
                                            </div>
                                            <span v-else>{{ field.currentValue || '-' }}</span>
                                        </td>
                                        <td class="ur-arrow-col">
                                            <i class="fas fa-arrow-right"></i>
                                        </td>
                                        <td>
                                            <div v-if="field.isAttachment && field.requestedAttachmentId"
                                                 class="ur-attachment-chip ur-field-sized">
                                                <i class="fas fa-file-pdf ur-chip-icon"></i>
                                                <span class="ur-chip-name ur-requested-value">
                                                    {{ field.requestedValue || $t('shared.delegationLetter') }}
                                                </span>
                                                <i class="fas fa-download ur-chip-download"
                                                   @click="downloadUpdateRequestAttachment(field.requestedAttachmentId, field.requestedValue)"></i>
                                            </div>
                                            <span v-else class="ur-requested-value">{{ field.requestedValue || '-' }}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="comparisonFields.length === 0">
                                        <td colspan="4" class="text-center">{{$t('shared.noDataFound')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="form-group ur-pending-comment" v-if="hasProviderComment">
                            <label>{{$t('shared.comment')}}</label>
                            <textarea class="form-control"
                                      :value="details.providerComment"
                                      disabled
                                      rows="2"></textarea>
                        </div>

                        <div class="form-row justify-content-between align-items-center mt-4 mr-2">
                            <div class="col-auto mr-2">
                                <button class="btn btn-outline-danger mr-2 ur-action-btn"
                                        @click="showRejectDialog">
                                    {{$t('dashboardPage.reject')}}
                                </button>
                                <button class="btn btn-primary ur-action-btn"
                                        @click="showApproveDialog">
                                    {{$t('dashboardPage.Approve')}}
                                </button>
                            </div>
                            <div class="col-auto mr-2">
                                <a class="link_danger" @click="back">{{$t('shared.back')}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" v-else>
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body ur-card-body">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.representativeName')}}</label>
                            <h4 class="user_info_txt">{{ details.requestedRepresentativeName || '-' }}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.representativeEmail')}}</label>
                            <h4 class="user_info_txt">{{ details.requestedRepresentativeEmail || '-' }}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.representativePhoneNumber')}}</label>
                            <h4 class="user_info_txt">{{ details.requestedRepresentativeMobile || '-' }}</h4>
                        </div>
                        <div class="col-md-4 mb-3" v-if="hasProviderComment">
                            <label class="user_info_header mb-0">{{$t('shared.comment')}}</label>
                            <h4 class="user_info_txt">{{ details.providerComment }}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.requestStatus')}}</label>
                            <h4 class="user_info_txt">{{ details.requestStatus || '-' }}</h4>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="user_info_header mb-0">{{$t('shared.delegationLetter')}}</label>
                            <div v-if="details.requestedDelegationLetterAttachmentId"
                                 class="ur-attachment-chip ur-field-sized">
                                <i class="fas fa-file-pdf ur-chip-icon"></i>
                                <span class="ur-chip-name">
                                    {{ details.requestedDelegationLetterFileName || $t('shared.delegationLetter') }}
                                </span>
                                <i class="fas fa-download ur-chip-download"
                                   @click="downloadUpdateRequestAttachment(details.requestedDelegationLetterAttachmentId, details.requestedDelegationLetterFileName)"></i>
                            </div>
                            <div v-else-if="details.currentDelegationLetterAttachmentId"
                                 class="ur-attachment-chip ur-field-sized">
                                <i class="fas fa-file-pdf ur-chip-icon"></i>
                                <span class="ur-chip-name">
                                    {{ details.currentDelegationLetterFileName || $t('shared.delegationLetter') }}
                                </span>
                                <i class="fas fa-download ur-chip-download"
                                   @click="downloadSenderRequestAttachment(details.currentDelegationLetterAttachmentId, details.currentDelegationLetterFileName)"></i>
                            </div>
                            <h4 v-else class="user_info_txt">-</h4>
                        </div>    
                    </div>
                    <div class="row" v-if="hasRejectionReason">
                        <div class="col-md-6 mb-3">
                            <div class="form-group mb-0">
                                <label>{{$t('senderInfo.rejectionReason')}}</label>
                                <textarea class="form-control"
                                          :value="details.rejectionReason"
                                          disabled
                                          rows="2"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form-row justify-content-end align-items-center mt-4 mr-2">
                        <div class="col-auto">
                            <a class="link_danger" @click="back">{{$t('shared.back')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card class="ur-confirm-dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideApproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p>{{$t('updateDataRequestsPage.approveConfirm')}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <button class="btn btn-outline-secondary px-5 py-2" @click="hideApproveDialog">
                                {{$t('shared.no')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="confirmApprove">
                                {{$t('shared.yes')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="rejectDialog" persistent width="554">
            <v-card class="ur-confirm-dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="text-center">{{$t('updateDataRequestsPage.rejectConfirm')}}</p>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group mb-0">
                                <label>{{$t('dashboardPage.rejectreason')}}</label>
                                <input class="form-control" v-model="rejectReason" type="text" />
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <button class="btn btn-outline-secondary px-5 py-2" @click="hideRejectDialog">
                                {{$t('shared.no')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2"
                                    :disabled="!rejectReasonIsValid"
                                    @click="confirmReject">
                                {{$t('shared.yes')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
